export default "__VITE_ASSET__CcJ5kuu5__"